import React from "react";
import { MapPin, Phone, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivateOfficeInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="private-office-information" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative w-full aspect-square lg:aspect-[4/3] rounded-sm overflow-hidden shadow-2xl border border-border/30 group">
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1563866/img/midnight_map_charlotte.png" alt="Map location of Cyradon Capital in Charlotte" className="w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-700 ease-in-out" />
            
            {}
            <div className="absolute inset-0 bg-blue-950/30 mix-blend-multiply pointer-events-none" />

            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-2">
              <div className="relative">
                <div className="absolute -inset-4 bg-primary/20 rounded-full blur-md animate-pulse" />
                <MapPin className="w-10 h-10 text-primary fill-primary/20 drop-shadow-[0_4px_6px_rgba(0,0,0,0.5)]" />
              </div>
              <span className="bg-background/90 backdrop-blur-md text-foreground text-xs font-medium px-3 py-1 rounded-full border border-border shadow-lg translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                Cyradon HQ
              </span>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-10 lg:pl-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl font-serif font-light tracking-tight text-foreground">
                Charlotte Headquarters
              </h2>
              <p className="text-muted-foreground max-w-md leading-relaxed">
                Located in the heart of the financial district, our private office offers a discreet and sophisticated environment for wealth planning.
              </p>
            </div>

            <div className="space-y-8 font-sans">
              {}
              <div className="flex items-start gap-5 group">
                <div className="p-3 rounded-full bg-secondary/10 border border-secondary/20 text-secondary shrink-0 mt-1 group-hover:bg-secondary/20 transition-colors">
                  <MapPin className="w-5 h-5" />
                </div>
                <div className="space-y-1">
                  <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                    Physical Address
                  </h3>
                  <p className="text-lg text-foreground leading-snug">4539 Hedgemore Drive
<div><br /></div><div><br /></div></p>
                  <Link to="https://maps.google.com" newTab className="inline-flex items-center gap-1 text-sm text-primary hover:text-primary/80 mt-2 transition-colors">
                    Get Directions <ArrowRight className="w-3 h-3" />
                  </Link>
                </div>
              </div>

              {}
              <div className="flex items-start gap-5 group">
                <div className="p-3 rounded-full bg-secondary/10 border border-secondary/20 text-secondary shrink-0 mt-1 group-hover:bg-secondary/20 transition-colors">
                  <Phone className="w-5 h-5" />
                </div>
                <div className="space-y-1">
                  <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider flex items-center gap-2">
                    Private Line <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                  </h3>
                  <Link to="tel:7045551234" className="text-2xl md:text-3xl font-light text-foreground hover:text-primary transition-colors block">
                    (704) 555-1234
                  </Link>
                  <p className="text-sm text-muted-foreground">
                    Direct access to our advisory team.
                  </p>
                </div>
              </div>

              {}
              <div className="flex items-start gap-5 group">
                <div className="p-3 rounded-full bg-secondary/10 border border-secondary/20 text-secondary shrink-0 mt-1 group-hover:bg-secondary/20 transition-colors">
                  <Clock className="w-5 h-5" />
                </div>
                <div className="space-y-1">
                  <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                    Office Hours
                  </h3>
                  <p className="text-lg text-foreground">
                    Monday - Friday: 9am - 5pm
                  </p>
                  <p className="text-sm text-muted-foreground">
                    Weekend appointments available by request.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <Button asChild variant="outline" className="border-primary/30 text-primary hover:bg-primary/10 hover:text-primary hover:border-primary/60 transition-all">
                <Link to="/contact">
                  Schedule a Private Consultation
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}